import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor} from '@elastic/eui';
import { stringToDecimal,toDecimalString } from '../../../../../shared/utils/numbers';

export const Formulario = (props)=>{
  
  let {onSave, selected, onClose} = props

  let [año,setAño] = useState(selected ? selected.año.toString() : undefined)
  let [dni,setDni] = useState(selected ? selected.dni : undefined)
  let [costeEmpresa,setCosteEmpresa] = useState(selected ? toDecimalString(selected.costeEmpresa) : undefined)
  let [horasConvenio, setHorasConvenio] = useState(selected ? selected.horasConvenio.toString() : undefined)
  let [indirectos, setIndirectos] = useState(selected ? selected.porcentajeIndirectos.toString() : undefined)

  const getData = () =>{
    let data ={
      año: parseInt(año),
      dni: dni,
      costeEmpresa: stringToDecimal(costeEmpresa),
      horasConvenio: stringToDecimal(horasConvenio),
      porcentajeIndirectos: stringToDecimal(indirectos)
    }
    return selected ? {...selected, ...data} : data
  }

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const comprobarErrores = () => {
    return isInvalidCosteEmpresa || isInvalidHorasConvenio || isInvalidIndirectos
  }

  const isInvalidAño = useMemo(() => año === undefined || año.trim() === "",[año])
  const isInvalidDni = useMemo(() => dni === undefined || dni.trim() === "",[dni])
  const isInvalidCosteEmpresa = useMemo(() => costeEmpresa === undefined || costeEmpresa.trim() === "",[costeEmpresa])
  const isInvalidHorasConvenio = useMemo(() => horasConvenio === undefined || horasConvenio.trim() === "",[horasConvenio])
  const isInvalidIndirectos = useMemo(() => indirectos === undefined || indirectos.trim() === "",[indirectos])

  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow fullWidth label="Año" isInvalid={isInvalidAño}>
            <EuiFieldText fullWidth maxLength={4} value={año} name="txtAño" onChange={e => setAño(e.target.value)} isInvalid={isInvalidAño} disabled={selected?true:false}/>
          </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
          <EuiFormRow fullWidth label="Dni" isInvalid={isInvalidDni}>
            <EuiFieldText fullWidth value={dni} name="txtDni" onChange={e => setDni(e.target.value)} isInvalid={isInvalidDni} disabled={selected?true:false}/>
          </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow fullWidth label="Coste Empresa" isInvalid={isInvalidCosteEmpresa}>
            <EuiFieldText fullWidth placeHolder="Ejemplo: 2.000,50" value={costeEmpresa} name="txtCosteEmpresa" onChange={e => setCosteEmpresa(e.target.value)} isInvalid={isInvalidCosteEmpresa}/>
          </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
          <EuiFormRow fullWidth label="Horas Convenio" isInvalid={isInvalidHorasConvenio}>
            <EuiFieldText fullWidth value={horasConvenio} name="txtHorasConvenio" onChange={e => setHorasConvenio(e.target.value)} isInvalid={isInvalidHorasConvenio}/>
          </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
          <EuiFormRow fullWidth label="Indirectos (%)" isInvalid={isInvalidIndirectos}>
            <EuiFieldText fullWidth value={indirectos} name="txtIndirectos" onChange={e => setIndirectos(e.target.value)} isInvalid={isInvalidIndirectos}/>
          </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="l" />
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;